import { Dayjs } from "dayjs";
import { useNavigate } from "react-router-dom";
import { useSelectedDate } from "../../shared/hooks/use-selected-date";
import { StyledContainer, StyledHeader, StyledContent, StyledButton } from "./about-project.style";

const AboutProject = () => {

    const navigate = useNavigate();

    const selectedDate: Dayjs = useSelectedDate();
    
    return (
        <StyledContainer>
            <StyledHeader>Hello</StyledHeader>
            <StyledContent>
                У каляндар знамянальных і памятных дат уключаны найбольш значныя даты з гісторыі, эканамічнага, навуковага і культурнага жыцця Магілёўскай вобласці, а таксама юбілейныя даты ўраджэнцаў і дзеячаў, якія пакінулі след у гісторыі вобласці. Матэрыял згрупаваны ў храналогіі дат, усе даты прыведзены па новаму стылю. У пачатку календара прыводзіцца пералік дат з нявызначаным месяцам. У каляндар уключаны падзеі, кратныя дзесяці гадам.

                Даведачны апарат выдання складаюць: паказальнік персаналій; паказальнік прадпрыемстваў, арганізацый і падзей; геаграфічны паказальнік (даецца адсылка да старонкі).

                Каляндар складзены на аснове фондаў Магілёўскай абласной бібліятэкі і рэсурсаў сеткі інтэрнэт.

                Выданне адрасавана супрацоўнікам бібліятэк, культурна-асветніцкіх устаноў, педагогам, студэнтам і навучэнцам, а таксама ўсім, хто цікавіцца гісторыяй і сучасным жыццём Магілёўскай вобласці.

                Будзем рады прапановам па ўключэнні новых дат або іх удакладненні, а таксама дапаўненням, якія дапамогуць пры складанні наступных выпускаў календара.
            </StyledContent>
            <StyledButton
                onClick={() =>
                    navigate(
                        selectedDate ? `/?date=${JSON.stringify(selectedDate)}` : "/",
                        {
                            replace: true,
                        }
                    )
                }
            >
                &#8592; Назад
            </StyledButton>
        </StyledContainer>
    )
};

export default AboutProject;